import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import pencilOrange from 'core/assets/svg/pencil-orange.svg';
import icLocked from 'core/assets/svg/icLocked.svg';
import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import { Tooltip } from 'core/components/tooltip';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import useStyles from './edit-referral.styles';

const EditReferral = ({ fromCheckout, inviter }) => {
  const { viewOnly, isAgency } = useSession();
  const history = useHistory();
  const formikCtx = useFormikContext();
  const classes = useStyles();
  const {
    offer: store,
    referralSearch: { setSearchString, setShowReferralMatches, searchCustomersAction }
  } = useStore();

  const hasInviter = inviter && inviter.firstName && inviter.lastName;
  const dirty = formikCtx && formikCtx.dirty;

  const canAddEditReferral = !viewOnly && !isAgency;

  const isLocked = canAddEditReferral && dirty;

  const onEditClick = () => {
    if (!canAddEditReferral) {
      return;
    }
    if (fromCheckout) {
      history.push(`/offer/${store.offer.id}`);
    }
    if (hasInviter) {
      setSearchString(`${inviter.firstName} ${inviter.lastName}`);
      searchCustomersAction();
    }
    setShowReferralMatches(true);
  };

  if (!hasInviter && !canAddEditReferral) {
    return null;
  }

  return (
    <Grid container item alignItems="center" className={classes.container}>
      <Label type="infoLabel">REFERRED BY</Label>
      <Label type="infoValue">{hasInviter ? `${inviter.firstName} ${inviter.lastName}` : 'None'}</Label>
      <Button
        color="secondary"
        variant="text"
        onClick={dirty || !canAddEditReferral ? null : onEditClick}
        className={classes.link}
      >
        <span className={isLocked ? classes.disabled : ''}>Add a referral</span>
        {isLocked ? (
          <Tooltip
            className={classes.tooltip}
            text="Please update offer price to save changes before adding a referral"
            placement="right"
            smallIcon={{ src: icLocked }}
            iconSize="icon16"
          />
        ) : (
          <img src={pencilOrange} alt={'edit'} className={classes.pencilIcon} />
        )}
      </Button>
    </Grid>
  );
};

EditReferral.propTypes = {
  fromCheckout: PropTypes.bool,
  inviter: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  })
};

EditReferral.defaultProps = {
  fromCheckout: false,
  inviter: null
};

export default EditReferral;
